import { Button, Grid, HStack, Skeleton, Stack, Text } from '@chakra-ui/react'
import type { Statistics } from 'BrokerTsLib/src/dtos'
import { useState } from 'react'

import { InsuranceCompaniesStats } from '@/components/InsuranceCompaniesStats'
import { StatLabel } from './StatLabel'

interface InsuranceCompaniesSectionProps {
  stats: Statistics
  isLoadingStats: boolean
}

export const InsuranceCompaniesSection = ({ stats, isLoadingStats }: InsuranceCompaniesSectionProps) => {
  const [selectedMetric, setSelectedMetric] = useState<'count' | 'totalValue'>('totalValue')

  const toggleSelectedMetric = () => {
    setSelectedMetric(prev => (prev === 'count' ? 'totalValue' : 'count'))
  }

  return (
    <Grid id='insurance-companies' gap={4}>
      <Stack sx={{ gap: { base: 2 } }}>
        <HStack sx={{ w: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <StatLabel>Pojišťovny</StatLabel>
          <Button h={6} px={2.5} mr={-2} mt={-1}
            // variant={selectedMetric == 'totalValue' ? 'solid' : 'outline'}
            variant="ghost"
            _focus={{ border: undefined }}
            onClick={toggleSelectedMetric}
          >
            <HStack gap={3}>
              <Text
                fontWeight={selectedMetric == 'totalValue' ? 'semibold' : 'normal'}>
                Kč
              </Text>

              <Text
                fontWeight={selectedMetric == 'count' ? 'semibold' : 'normal'}>
                ks
              </Text>
            </HStack>
          </Button>
        </HStack>

        <Skeleton isLoaded={!isLoadingStats} height={isLoadingStats ? '120px' : ''} as={Stack} gap={2}>
          <InsuranceCompaniesStats
            companies={stats.insurers}
            selectedMetric={selectedMetric}
          />
        </Skeleton>
      </Stack >
    </Grid >
  )
}
